<template>
  <v-container fluid :class="{ 'recepcion-dark': $vuetify.theme.dark }">
    <v-row class="mb-2" align="center">
      <v-col>
        <span class="text-h6 font-weight-bold">Recepción 0km con daños</span>
        <div class="caption contexto-caption mt-1">
          Últimos 6 caracteres del VIN (alfanumérico) y fotografías obligatorias.
        </div>
        <v-alert v-if="contextoError" type="error" dense outlined class="mt-3 mb-0">
          {{ contextoError }}
        </v-alert>
        <div v-else-if="contexto" class="caption mt-2">
          <strong>Empresa:</strong> {{ contexto.empresa_nombre || '—' }}
          &nbsp;·&nbsp;
          <strong>Sucursal:</strong> {{ contexto.sucursal_nombre || '—' }}
        </div>
      </v-col>
      <v-col cols="12" sm="5" md="5" class="py-0 d-flex align-center justify-md-end justify-start">
        <v-btn class="recepcion-header-btn" outlined color="info" :loading="cargandoListado" @click="abrirListado">
          <v-icon left>fas fa-table</v-icon>
          Registros cargados
        </v-btn>
      </v-col>
    </v-row>

    <v-card outlined class="pa-4">
      <v-form ref="form" v-model="formValido">
        <v-row dense class="recepcion-header-actions">
          <v-col cols="12" sm="6" md="4" class="py-0">
            <v-text-field v-model="vin" label="Últimos 6 caracteres del VIN *" hint="Letras y números, hasta 6"
              persistent-hint maxlength="6" outlined dense :rules="reglasVin" @input="onVinInput" />
          </v-col>

        </v-row>


        <v-divider class="my-4" />
        <div class="text-subtitle-2 mb-3 recepcion-section-title">Fotografías</div>

        <v-row dense>
          <v-col cols="12">
            <div class="field-label">Fotos de los daños *</div>
            <div class="thumb-grid">
              <div v-for="(url, i) in previewDanos" :key="'d' + i" class="thumb-cell">
                <img :src="url" alt="" @click="openViewer(url, 'Daño ' + (i + 1))">
                <v-btn icon x-small dark class="thumb-remove" aria-label="Quitar" @click.stop="removeDano(i)">
                  <v-icon x-small>fas fa-times</v-icon>
                </v-btn>
              </div>
              <button type="button" class="upload-placeholder" @click="$refs.inDanos.click()">
                <v-icon color="primary" size="64">fas fa-plus</v-icon>
              </button>
            </div>
            <input ref="inDanos" type="file" accept="image/*" multiple class="d-none" @change="onPickDanos">
          </v-col>

          <v-col cols="12" sm="6">
            <div class="field-label">Foto del número de VIN *</div>
            <button v-if="!previewVin" type="button" class="upload-placeholder upload-placeholder--single"
              @click="$refs.inVin.click()">
              <v-icon color="primary" size="64">fas fa-plus</v-icon>
              <span class="upload-hint">Tocá para agregar</span>
            </button>
            <div v-else class="thumb-cell thumb-cell--single">
              <img :src="previewVin" alt="" @click="openViewer(previewVin, 'VIN')">
              <v-btn icon x-small dark class="thumb-remove" aria-label="Quitar" @click.stop="clearVin">
                <v-icon x-small>fas fa-times</v-icon>
              </v-btn>
            </div>
            <input ref="inVin" type="file" accept="image/*" class="d-none" @change="onPickVin">
          </v-col>

          <v-col cols="12" sm="6">
            <div class="field-label">Frente del remito del vehículo *</div>
            <button v-if="!previewRemitoFrente" type="button" class="upload-placeholder upload-placeholder--single"
              @click="$refs.inRf.click()">
              <v-icon color="primary" size="64">fas fa-plus</v-icon>
              <span class="upload-hint">Tocá para agregar</span>
            </button>
            <div v-else class="thumb-cell thumb-cell--single">
              <img :src="previewRemitoFrente" alt=""
                @click="openViewer(previewRemitoFrente, 'Remito vehículo — frente')">
              <v-btn icon x-small dark class="thumb-remove" aria-label="Quitar" @click.stop="clearRemitoFrente">
                <v-icon x-small>fas fa-times</v-icon>
              </v-btn>
            </div>
            <input ref="inRf" type="file" accept="image/*" class="d-none" @change="onPickRemitoFrente">
          </v-col>

          <v-col cols="12" sm="6">
            <div class="field-label">Dorso del remito del vehículo *</div>
            <button v-if="!previewRemitoDorso" type="button" class="upload-placeholder upload-placeholder--single"
              @click="$refs.inRd.click()">
              <v-icon color="primary" size="64">fas fa-plus</v-icon>
              <span class="upload-hint">Tocá para agregar</span>
            </button>
            <div v-else class="thumb-cell thumb-cell--single">
              <img :src="previewRemitoDorso" alt="" @click="openViewer(previewRemitoDorso, 'Remito vehículo — dorso')">
              <v-btn icon x-small dark class="thumb-remove" aria-label="Quitar" @click.stop="clearRemitoDorso">
                <v-icon x-small>fas fa-times</v-icon>
              </v-btn>
            </div>
            <input ref="inRd" type="file" accept="image/*" class="d-none" @change="onPickRemitoDorso">
          </v-col>

          <v-col cols="12" sm="6">
            <div class="field-label">Remito del camión / carta de porte *</div>
            <button v-if="!previewRemitoCamion" type="button" class="upload-placeholder upload-placeholder--single"
              @click="$refs.inRc.click()">
              <v-icon color="primary" size="64">fas fa-plus</v-icon>
              <span class="upload-hint">Tocá para agregar</span>
            </button>
            <div v-else class="thumb-cell thumb-cell--single">
              <img :src="previewRemitoCamion" alt=""
                @click="openViewer(previewRemitoCamion, 'Remito camión / carta de porte')">
              <v-btn icon x-small dark class="thumb-remove" aria-label="Quitar" @click.stop="clearRemitoCamion">
                <v-icon x-small>fas fa-times</v-icon>
              </v-btn>
            </div>
            <input ref="inRc" type="file" accept="image/*" class="d-none" @change="onPickRemitoCamion">
          </v-col>
        </v-row>

        <v-row class="mt-4">
          <v-col class="acciones-col">
            <v-btn color="primary" :loading="enviando" :disabled="!puedeEnviar" @click="enviar">
              <v-icon left>fas fa-paper-plane</v-icon>
              Enviar registro
            </v-btn>

          </v-col>
        </v-row>
      </v-form>
    </v-card>

    <v-dialog v-model="dialogListado" max-width="1200px">
      <v-card>
        <v-card-title class="d-flex justify-space-between align-center">
          <span>Recepción 0km con daños - Registros</span>
          <v-btn icon @click="dialogListado = false"><v-icon>fas fa-times</v-icon></v-btn>
        </v-card-title>
        <v-card-text>
          <v-data-table :headers="headersListado" :items="listadoRecepciones" :loading="cargandoListado" dense>
            <template #[`item.vin_ultimos_6`]="{ item }">
              {{ String(item.vin_ultimos_6 || '').trim() || '—' }}
            </template>
            <template #[`item.archivos`]="{ item }">
              {{ (item.archivos || []).length }}
            </template>
            <template #[`item.fecha_alta`]="{ item }">
              {{ formatFechaAlta(item.fecha_alta) }}
            </template>
            <template #[`item.acciones`]="{ item }">
              <v-btn x-small outlined color="primary" @click="abrirEditar(item)">
                <v-icon x-small left>fas fa-edit</v-icon>Editar
              </v-btn>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogEditar" max-width="900px">
      <v-card>
        <v-card-title>Editar recepción #{{ editForm.id || '—' }}</v-card-title>
        <v-card-text>
          <v-text-field v-model="editForm.vin_ultimos_6" label="Últimos 6 caracteres del VIN" maxlength="6" outlined
            dense
            @input="editForm.vin_ultimos_6 = String(editForm.vin_ultimos_6 || '').toUpperCase().replace(/[^A-Z0-9]/g, '').slice(0, 6)" />
          <div class="subtitle-2 mb-2 recepcion-section-title">Fotos actuales</div>
          <div class="field-label">Fotos de los daños</div>
          <div class="thumb-grid mb-3">
            <div v-for="a in getEditDanosActivos()" :key="`ed-${a.id}`" class="thumb-cell">
              <img :src="a.archivo_url" alt="" @click="openViewer(a.archivo_url, tipoArchivoLabel(a.tipo_archivo, a.orden))">
              <div class="thumb-kind">{{ tipoArchivoLabel(a.tipo_archivo, a.orden) }}</div>
              <v-btn small color="error" class="edit-delete-btn" @click="eliminarArchivoExistente(a.id)">
                Eliminar
              </v-btn>
            </div>
            <div v-for="(url, i) in editForm.previewNuevosDano" :key="`newd-${i}`" class="thumb-cell">
              <img :src="url" alt="" @click="openViewer(url, `Nuevo daño ${i + 1}`)">
              <div class="thumb-kind">Daño nuevo #{{ i + 1 }}</div>
              <v-btn small color="error" class="edit-delete-btn" @click="removeEditDanoNuevo(i)">
                Eliminar
              </v-btn>
            </div>
            <button type="button" class="upload-placeholder" @click="$refs.inEditDanos.click()">
              <v-icon color="primary" size="64">fas fa-plus</v-icon>
            </button>
          </div>
          <input ref="inEditDanos" type="file" accept="image/*" multiple class="d-none" @change="onPickEditDanos">

          <v-row dense>
            <v-col cols="12" sm="6">
              <div class="field-label">Foto del número de VIN</div>
              <button v-if="!getEditSingleActivo('VIN') && !editForm.previewNuevoVin" type="button"
                class="upload-placeholder upload-placeholder--single" @click="$refs.inEditVin.click()">
                <v-icon color="primary" size="48">fas fa-plus</v-icon>
                <span class="upload-hint">Tocá para agregar</span>
              </button>
              <div v-else class="thumb-cell thumb-cell--single">
                <img :src="editForm.previewNuevoVin || getEditSingleActivo('VIN').archivo_url" alt=""
                  @click="openViewer(editForm.previewNuevoVin || getEditSingleActivo('VIN').archivo_url, 'VIN')">
                <div class="thumb-kind">{{ editForm.previewNuevoVin ? 'VIN nuevo' : 'VIN' }}</div>
                <v-btn small color="error" class="edit-delete-btn" @click="clearEditSingle('VIN')">Eliminar</v-btn>
              </div>
              <input ref="inEditVin" type="file" accept="image/*" class="d-none" @change="onPickEditSingle($event, 'VIN')">
            </v-col>
            <v-col cols="12" sm="6">
              <div class="field-label">Frente del remito del vehículo</div>
              <button v-if="!getEditSingleActivo('REMITO_FRENTE') && !editForm.previewNuevoRemitoFrente" type="button"
                class="upload-placeholder upload-placeholder--single" @click="$refs.inEditRf.click()">
                <v-icon color="primary" size="48">fas fa-plus</v-icon>
                <span class="upload-hint">Tocá para agregar</span>
              </button>
              <div v-else class="thumb-cell thumb-cell--single">
                <img :src="editForm.previewNuevoRemitoFrente || getEditSingleActivo('REMITO_FRENTE').archivo_url" alt=""
                  @click="openViewer(editForm.previewNuevoRemitoFrente || getEditSingleActivo('REMITO_FRENTE').archivo_url, 'Remito frente')">
                <div class="thumb-kind">{{ editForm.previewNuevoRemitoFrente ? 'Remito frente nuevo' : 'Remito frente' }}</div>
                <v-btn small color="error" class="edit-delete-btn" @click="clearEditSingle('REMITO_FRENTE')">Eliminar</v-btn>
              </div>
              <input ref="inEditRf" type="file" accept="image/*" class="d-none"
                @change="onPickEditSingle($event, 'REMITO_FRENTE')">
            </v-col>
            <v-col cols="12" sm="6">
              <div class="field-label">Dorso del remito del vehículo</div>
              <button v-if="!getEditSingleActivo('REMITO_DORSO') && !editForm.previewNuevoRemitoDorso" type="button"
                class="upload-placeholder upload-placeholder--single" @click="$refs.inEditRd.click()">
                <v-icon color="primary" size="48">fas fa-plus</v-icon>
                <span class="upload-hint">Tocá para agregar</span>
              </button>
              <div v-else class="thumb-cell thumb-cell--single">
                <img :src="editForm.previewNuevoRemitoDorso || getEditSingleActivo('REMITO_DORSO').archivo_url" alt=""
                  @click="openViewer(editForm.previewNuevoRemitoDorso || getEditSingleActivo('REMITO_DORSO').archivo_url, 'Remito dorso')">
                <div class="thumb-kind">{{ editForm.previewNuevoRemitoDorso ? 'Remito dorso nuevo' : 'Remito dorso' }}</div>
                <v-btn small color="error" class="edit-delete-btn" @click="clearEditSingle('REMITO_DORSO')">Eliminar</v-btn>
              </div>
              <input ref="inEditRd" type="file" accept="image/*" class="d-none"
                @change="onPickEditSingle($event, 'REMITO_DORSO')">
            </v-col>
            <v-col cols="12" sm="6">
              <div class="field-label">Remito del camión / carta de porte</div>
              <button v-if="!getEditSingleActivo('REMITO_CAMION') && !editForm.previewNuevoRemitoCamion" type="button"
                class="upload-placeholder upload-placeholder--single" @click="$refs.inEditRc.click()">
                <v-icon color="primary" size="48">fas fa-plus</v-icon>
                <span class="upload-hint">Tocá para agregar</span>
              </button>
              <div v-else class="thumb-cell thumb-cell--single">
                <img :src="editForm.previewNuevoRemitoCamion || getEditSingleActivo('REMITO_CAMION').archivo_url" alt=""
                  @click="openViewer(editForm.previewNuevoRemitoCamion || getEditSingleActivo('REMITO_CAMION').archivo_url, 'Remito camión')">
                <div class="thumb-kind">{{ editForm.previewNuevoRemitoCamion ? 'Remito camión nuevo' : 'Remito camión' }}</div>
                <v-btn small color="error" class="edit-delete-btn" @click="clearEditSingle('REMITO_CAMION')">Eliminar</v-btn>
              </div>
              <input ref="inEditRc" type="file" accept="image/*" class="d-none"
                @change="onPickEditSingle($event, 'REMITO_CAMION')">
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text @click="cerrarDialogEditar">Cancelar</v-btn>
          <v-btn color="primary" :loading="guardandoEdicion" @click="guardarEdicion">
            Guardar cambios
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <ImgViewer v-model="viewerOpen" :img="viewerImg" :nombre="viewerNombre" />

    <v-snackbar v-model="snackbar.value" :color="snackbar.color" top right :timeout="5000">
      {{ snackbar.text }}
      <template #action>
        <v-btn text @click="snackbar.value = false">Cerrar</v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>

<script>
import moment from 'moment'
import ImgViewer from '../../../components/util/ImgViewer.vue'

export default {
  name: 'Recepcion0kmDanos',

  components: {
    ImgViewer,
  },

  data() {
    return {
      formValido: false,
      enviando: false,
      vin: '',
      contexto: null,
      contextoError: null,
      fotosDanos: [],
      previewDanos: [],
      fotoVin: null,
      previewVin: '',
      fotoRemitoFrente: null,
      previewRemitoFrente: '',
      fotoRemitoDorso: null,
      previewRemitoDorso: '',
      fotoRemitoCamion: null,
      previewRemitoCamion: '',
      viewerOpen: false,
      viewerImg: '',
      viewerNombre: '',
      dialogListado: false,
      cargandoListado: false,
      listadoRecepciones: [],
      headersListado: [
        { text: 'ID', value: 'id' },
        // { text: 'Ticket', value: 'ticket_id' },
        { text: 'VIN (ult.6)', value: 'vin_ultimos_6' },
        { text: 'Empresa', value: 'empresa_nombre' },
        { text: 'Sucursal', value: 'sucursal_nombre' },
        { text: 'Fecha alta', value: 'fecha_alta' },
        { text: 'Fotos', value: 'archivos' },
        { text: 'Acciones', value: 'acciones', sortable: false },
      ],
      dialogEditar: false,
      guardandoEdicion: false,
      editForm: {
        id: null,
        vin_ultimos_6: '',
        archivos: [],
        archivosEliminarIds: [],
        autoDeleteArchivoIds: [],
        nuevosArchivosDano: [],
        previewNuevosDano: [],
        nuevoArchivoVin: null,
        previewNuevoVin: '',
        nuevoArchivoRemitoFrente: null,
        previewNuevoRemitoFrente: '',
        nuevoArchivoRemitoDorso: null,
        previewNuevoRemitoDorso: '',
        nuevoArchivoRemitoCamion: null,
        previewNuevoRemitoCamion: '',
      },
      reglasVin: [
        (v) => !!v || 'Ingrese el VIN',
        (v) =>
          /^[a-zA-Z0-9]{1,6}$/.test(String(v || '').trim()) ||
          'Solo letras y números, entre 1 y 6 caracteres',
      ],
      snackbar: { value: false, text: '', color: '' },
    }
  },

  computed: {
    fotosCompletas() {
      return (
        this.fotosDanos.length > 0 &&
        !!this.fotoVin &&
        !!this.fotoRemitoFrente &&
        !!this.fotoRemitoDorso &&
        !!this.fotoRemitoCamion
      )
    },

    puedeEnviar() {
      return this.formValido && this.fotosCompletas && !!this.contexto && !this.contextoError
    },
  },

  async mounted() {
    const res = await this.$store.dispatch('postventaTickets/getMiContextoRecepcion')
    if (res.exito) {
      this.contexto = res.data
    } else {
      this.contextoError = res.message || 'No se pudo obtener empresa/sucursal del usuario.'
    }
  },

  beforeDestroy() {
    this.revokeAllObjectUrls()
  },

  methods: {
    revokeAllObjectUrls() {
      this.previewDanos.forEach((u) => {
        if (u && u.startsWith('blob:')) URL.revokeObjectURL(u)
      })
        ;[this.previewVin, this.previewRemitoFrente, this.previewRemitoDorso, this.previewRemitoCamion].forEach((u) => {
          if (u && u.startsWith('blob:')) URL.revokeObjectURL(u)
        })
    },

    onVinInput() {
      this.vin = String(this.vin || '')
        .toUpperCase()
        .replace(/[^A-Z0-9]/g, '')
        .slice(0, 6)
    },

    onPickDanos(e) {
      const files = Array.from(e.target.files || []).filter((f) => f.type.startsWith('image/'))
      e.target.value = ''
      for (const f of files) {
        this.fotosDanos.push(f)
        this.previewDanos.push(URL.createObjectURL(f))
      }
    },

    removeDano(i) {
      const u = this.previewDanos[i]
      if (u && u.startsWith('blob:')) URL.revokeObjectURL(u)
      this.previewDanos.splice(i, 1)
      this.fotosDanos.splice(i, 1)
    },

    setSingleFile(file, keyFile, keyPreview) {
      if (!file || !file.type.startsWith('image/')) return
      const prev = this[keyPreview]
      if (prev && prev.startsWith('blob:')) URL.revokeObjectURL(prev)
      this[keyFile] = file
      this[keyPreview] = URL.createObjectURL(file)
    },

    onPickVin(e) {
      const f = (e.target.files || [])[0]
      e.target.value = ''
      this.setSingleFile(f, 'fotoVin', 'previewVin')
    },

    onPickRemitoFrente(e) {
      const f = (e.target.files || [])[0]
      e.target.value = ''
      this.setSingleFile(f, 'fotoRemitoFrente', 'previewRemitoFrente')
    },

    onPickRemitoDorso(e) {
      const f = (e.target.files || [])[0]
      e.target.value = ''
      this.setSingleFile(f, 'fotoRemitoDorso', 'previewRemitoDorso')
    },

    onPickRemitoCamion(e) {
      const f = (e.target.files || [])[0]
      e.target.value = ''
      this.setSingleFile(f, 'fotoRemitoCamion', 'previewRemitoCamion')
    },

    clearVin() {
      if (this.previewVin && this.previewVin.startsWith('blob:')) URL.revokeObjectURL(this.previewVin)
      this.fotoVin = null
      this.previewVin = ''
    },

    clearRemitoFrente() {
      if (this.previewRemitoFrente && this.previewRemitoFrente.startsWith('blob:')) {
        URL.revokeObjectURL(this.previewRemitoFrente)
      }
      this.fotoRemitoFrente = null
      this.previewRemitoFrente = ''
    },

    clearRemitoDorso() {
      if (this.previewRemitoDorso && this.previewRemitoDorso.startsWith('blob:')) {
        URL.revokeObjectURL(this.previewRemitoDorso)
      }
      this.fotoRemitoDorso = null
      this.previewRemitoDorso = ''
    },

    clearRemitoCamion() {
      if (this.previewRemitoCamion && this.previewRemitoCamion.startsWith('blob:')) {
        URL.revokeObjectURL(this.previewRemitoCamion)
      }
      this.fotoRemitoCamion = null
      this.previewRemitoCamion = ''
    },

    openViewer(img, nombre) {
      if (!img) return
      this.viewerImg = img
      this.viewerNombre = nombre || 'Imagen'
      this.viewerOpen = true
    },

    extFromFile(file) {
      const n = (file && file.name) || ''
      const dot = n.lastIndexOf('.')
      return dot >= 0 ? n.slice(dot).toLowerCase() : '.jpg'
    },

    fileToBase64(file) {
      return new Promise((resolve) => {
        const reader = new FileReader()
        reader.onload = (e) => resolve(e.target.result)
        reader.readAsDataURL(file)
      })
    },

    async armarPayload() {
      const archivos = []
      const nombreArchivos = []

      let idx = 0
      for (const f of this.fotosDanos) {
        idx += 1
        archivos.push(await this.fileToBase64(f))
        nombreArchivos.push(`dano_${String(idx).padStart(2, '0')}${this.extFromFile(f)}`)
      }

      archivos.push(await this.fileToBase64(this.fotoVin))
      nombreArchivos.push(`vin${this.extFromFile(this.fotoVin)}`)

      archivos.push(await this.fileToBase64(this.fotoRemitoFrente))
      nombreArchivos.push(`remito_vehiculo_frente${this.extFromFile(this.fotoRemitoFrente)}`)

      archivos.push(await this.fileToBase64(this.fotoRemitoDorso))
      nombreArchivos.push(`remito_vehiculo_dorso${this.extFromFile(this.fotoRemitoDorso)}`)

      archivos.push(await this.fileToBase64(this.fotoRemitoCamion))
      nombreArchivos.push(`remito_camion_carta_porte${this.extFromFile(this.fotoRemitoCamion)}`)

      return {
        vin_ultimos_6: String(this.vin).trim(),
        archivos,
        nombreArchivos,
      }
    },

    async enviar() {
      if (!this.$refs.form.validate()) return
      if (!this.fotosCompletas) {
        this.mostrarSnackbar('Complete todas las fotografías obligatorias.', 'warning')
        return
      }
      if (!this.contexto) {
        this.mostrarSnackbar(this.contextoError || 'Sin contexto de usuario.', 'error')
        return
      }
      this.enviando = true
      try {
        const payload = await this.armarPayload()
        const res = await this.$store.dispatch('postventaTickets/recepcion0km', payload)
        if (res.exito) {
          const text = res.message || 'Registro creado.'
          if (res.exito_stark === false) {
            this.mostrarSnackbar(text, 'warning')
          } else {
            this.mostrarSnackbar(text, 'success')
          }
          this.resetForm()
        } else {
          this.mostrarSnackbar(res.message || 'Error al enviar.', 'error')
        }
      } catch (e) {
        this.mostrarSnackbar(e.message || 'Error de red.', 'error')
      } finally {
        this.enviando = false
      }
    },

    async abrirListado() {
      this.dialogListado = true
      this.cargandoListado = true
      try {
        const res = await this.$store.dispatch('postventaTickets/getRecepcion0kmListado')
        this.listadoRecepciones = res.exito ? (res.data || []) : []
      } finally {
        this.cargandoListado = false
      }
    },

    abrirEditar(item) {
      this.editForm = {
        id: item.id,
        vin_ultimos_6: String(item.vin_ultimos_6 || '').trim(),
        archivos: item.archivos || [],
        archivosEliminarIds: [],
        autoDeleteArchivoIds: [],
        nuevosArchivosDano: [],
        previewNuevosDano: [],
        nuevoArchivoVin: null,
        previewNuevoVin: '',
        nuevoArchivoRemitoFrente: null,
        previewNuevoRemitoFrente: '',
        nuevoArchivoRemitoDorso: null,
        previewNuevoRemitoDorso: '',
        nuevoArchivoRemitoCamion: null,
        previewNuevoRemitoCamion: '',
      }
      this.dialogEditar = true
    },
    cerrarDialogEditar() {
      this.revokeEditObjectUrls()
      this.dialogEditar = false
    },
    revokeEditObjectUrls() {
      ;(this.editForm.previewNuevosDano || []).forEach((u) => {
        if (u && u.startsWith('blob:')) URL.revokeObjectURL(u)
      })
      ;[
        this.editForm.previewNuevoVin,
        this.editForm.previewNuevoRemitoFrente,
        this.editForm.previewNuevoRemitoDorso,
        this.editForm.previewNuevoRemitoCamion,
      ].forEach((u) => {
        if (u && u.startsWith('blob:')) URL.revokeObjectURL(u)
      })
    },
    isArchivoMarcadoEliminar(id) {
      return this.editForm.archivosEliminarIds.includes(id)
    },
    marcarArchivoEliminar(id) {
      if (!this.editForm.archivosEliminarIds.includes(id)) {
        this.editForm.archivosEliminarIds.push(id)
      }
    },
    desmarcarArchivoEliminar(id) {
      const idx = this.editForm.archivosEliminarIds.indexOf(id)
      if (idx >= 0) this.editForm.archivosEliminarIds.splice(idx, 1)
    },
    eliminarArchivoExistente(id) {
      this.marcarArchivoEliminar(id)
      const autoIdx = this.editForm.autoDeleteArchivoIds.indexOf(id)
      if (autoIdx >= 0) this.editForm.autoDeleteArchivoIds.splice(autoIdx, 1)
    },
    getEditDanosActivos() {
      return (this.editForm.archivos || []).filter(
        (a) =>
          String(a.tipo_archivo || '').toUpperCase() === 'DANO' &&
          !this.editForm.archivosEliminarIds.includes(a.id)
      )
    },
    getEditSingleActivo(tipo) {
      const t = String(tipo || '').toUpperCase()
      return (this.editForm.archivos || []).find(
        (a) =>
          String(a.tipo_archivo || '').toUpperCase() === t &&
          !this.editForm.archivosEliminarIds.includes(a.id)
      )
    },
    getEditSingleOriginal(tipo) {
      const t = String(tipo || '').toUpperCase()
      return (this.editForm.archivos || []).find((a) => String(a.tipo_archivo || '').toUpperCase() === t)
    },
    onPickEditDanos(e) {
      const files = Array.from(e.target.files || []).filter((f) => f.type && f.type.startsWith('image/'))
      e.target.value = ''
      for (const f of files) {
        this.editForm.nuevosArchivosDano.push(f)
        this.editForm.previewNuevosDano.push(URL.createObjectURL(f))
      }
    },
    removeEditDanoNuevo(i) {
      const u = this.editForm.previewNuevosDano[i]
      if (u && u.startsWith('blob:')) URL.revokeObjectURL(u)
      this.editForm.previewNuevosDano.splice(i, 1)
      this.editForm.nuevosArchivosDano.splice(i, 1)
    },
    onPickEditSingle(e, tipo) {
      const file = (e.target.files || [])[0]
      e.target.value = ''
      if (!file || !file.type || !file.type.startsWith('image/')) return
      const map = {
        VIN: ['nuevoArchivoVin', 'previewNuevoVin'],
        REMITO_FRENTE: ['nuevoArchivoRemitoFrente', 'previewNuevoRemitoFrente'],
        REMITO_DORSO: ['nuevoArchivoRemitoDorso', 'previewNuevoRemitoDorso'],
        REMITO_CAMION: ['nuevoArchivoRemitoCamion', 'previewNuevoRemitoCamion'],
      }
      const pair = map[String(tipo || '').toUpperCase()]
      if (!pair) return
      const [fileKey, previewKey] = pair
      const prev = this.editForm[previewKey]
      if (prev && prev.startsWith('blob:')) URL.revokeObjectURL(prev)
      const existente = this.getEditSingleActivo(tipo)
      if (existente?.id) {
        this.marcarArchivoEliminar(existente.id)
        if (!this.editForm.autoDeleteArchivoIds.includes(existente.id)) {
          this.editForm.autoDeleteArchivoIds.push(existente.id)
        }
      }
      this.editForm[fileKey] = file
      this.editForm[previewKey] = URL.createObjectURL(file)
    },
    clearEditSingle(tipo) {
      const t = String(tipo || '').toUpperCase()
      const map = {
        VIN: ['nuevoArchivoVin', 'previewNuevoVin'],
        REMITO_FRENTE: ['nuevoArchivoRemitoFrente', 'previewNuevoRemitoFrente'],
        REMITO_DORSO: ['nuevoArchivoRemitoDorso', 'previewNuevoRemitoDorso'],
        REMITO_CAMION: ['nuevoArchivoRemitoCamion', 'previewNuevoRemitoCamion'],
      }
      const pair = map[t]
      if (pair) {
        const [fileKey, previewKey] = pair
        const prev = this.editForm[previewKey]
        const teniaPreviewNueva = !!prev
        if (prev && prev.startsWith('blob:')) URL.revokeObjectURL(prev)
        this.editForm[fileKey] = null
        this.editForm[previewKey] = ''
        if (teniaPreviewNueva) {
          const original = this.getEditSingleOriginal(t)
          if (original?.id && this.editForm.autoDeleteArchivoIds.includes(original.id)) {
            this.desmarcarArchivoEliminar(original.id)
            this.editForm.autoDeleteArchivoIds = this.editForm.autoDeleteArchivoIds.filter((id) => id !== original.id)
            return
          }
        }
      }
      const existente = this.getEditSingleActivo(t)
      if (existente?.id) this.marcarArchivoEliminar(existente.id)
    },
    validarEdicionFotosObligatorias() {
      const danosCount = this.getEditDanosActivos().length + (this.editForm.nuevosArchivosDano || []).length
      const hasVin = !!this.getEditSingleActivo('VIN') || !!this.editForm.nuevoArchivoVin
      const hasFrente = !!this.getEditSingleActivo('REMITO_FRENTE') || !!this.editForm.nuevoArchivoRemitoFrente
      const hasDorso = !!this.getEditSingleActivo('REMITO_DORSO') || !!this.editForm.nuevoArchivoRemitoDorso
      const hasCamion = !!this.getEditSingleActivo('REMITO_CAMION') || !!this.editForm.nuevoArchivoRemitoCamion
      if (danosCount < 1 || !hasVin || !hasFrente || !hasDorso || !hasCamion) {
        return 'No se puede guardar: deben quedar al menos una foto de daños, VIN, frente y dorso del remito del vehículo, y remito del camión / carta de porte.'
      }
      return null
    },

    async guardarEdicion() {
      if (!this.editForm.id) return
      const errFotos = this.validarEdicionFotosObligatorias()
      if (errFotos) {
        this.mostrarSnackbar(errFotos, 'warning')
        return
      }
      this.guardandoEdicion = true
      try {
        const archivos = []
        const nombreArchivos = []
        let idxDano = 0
        for (const f of (this.editForm.nuevosArchivosDano || [])) {
          if (!f || !f.type || !f.type.startsWith('image/')) continue
          idxDano += 1
          archivos.push(await this.fileToBase64(f))
          nombreArchivos.push(`dano_${String(idxDano).padStart(2, '0')}${this.extFromFile(f)}`)
        }
        const pushSingle = async (file, nombreBase) => {
          if (!file || !file.type || !file.type.startsWith('image/')) return
          archivos.push(await this.fileToBase64(file))
          nombreArchivos.push(`${nombreBase}${this.extFromFile(file)}`)
        }
        await pushSingle(this.editForm.nuevoArchivoVin, 'vin')
        await pushSingle(this.editForm.nuevoArchivoRemitoFrente, 'remito_vehiculo_frente')
        await pushSingle(this.editForm.nuevoArchivoRemitoDorso, 'remito_vehiculo_dorso')
        await pushSingle(this.editForm.nuevoArchivoRemitoCamion, 'remito_camion_carta_porte')

        const res = await this.$store.dispatch('postventaTickets/actualizarRecepcion0km', {
          recepcion_id: this.editForm.id,
          vin_ultimos_6: this.editForm.vin_ultimos_6,
          archivos,
          nombreArchivos,
          archivos_eliminar_ids: this.editForm.archivosEliminarIds,
        })

        if (res.exito) {
          this.mostrarSnackbar(res.message || 'Registro actualizado.', 'success')
          this.cerrarDialogEditar()
          await this.abrirListado()
        } else {
          this.mostrarSnackbar(res.message || 'No se pudo actualizar.', 'error')
        }
      } finally {
        this.guardandoEdicion = false
      }
    },

    resetForm() {
      this.revokeAllObjectUrls()
      this.vin = ''
      this.fotosDanos = []
      this.previewDanos = []
      this.fotoVin = null
      this.previewVin = ''
      this.fotoRemitoFrente = null
      this.previewRemitoFrente = ''
      this.fotoRemitoDorso = null
      this.previewRemitoDorso = ''
      this.fotoRemitoCamion = null
      this.previewRemitoCamion = ''
      this.$nextTick(() => this.$refs.form && this.$refs.form.resetValidation())
    },

    mostrarSnackbar(text, color) {
      this.snackbar = { value: true, text, color }
    },
    tipoArchivoLabel(tipo, orden) {
      const map = {
        DANO: 'Daño',
        VIN: 'VIN',
        REMITO_FRENTE: 'Remito frente',
        REMITO_DORSO: 'Remito dorso',
        REMITO_CAMION: 'Remito camión',
      }
      const base = map[String(tipo || '').toUpperCase()] || 'Foto'
      if (String(tipo || '').toUpperCase() === 'DANO' && Number(orden) > 0) return `${base} #${orden}`
      return base
    },
    formatFechaAlta(fecha) {
      if (!fecha) return '—'
      return moment.utc(fecha).format('DD/MM/YYYY HH:mm')
    },
  },
}
</script>

<style scoped>
.field-label {
  font-size: 0.875rem;
  font-weight: 500;
  margin-bottom: 8px;
  color: var(--v-tabText-base);
}

.contexto-caption {
  color: var(--v-swalText-base);
  opacity: 0.78;
}

.recepcion-section-title {
  color: var(--v-tabText-base);
}

::v-deep .v-dialog .v-card__title {
  color: var(--v-tabText-base);
}

.thumb-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  align-items: flex-start;
}

.acciones-col {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
}

.recepcion-header-actions {
  align-items: center;
  justify-content: space-between;
}

.recepcion-header-btn {
  margin-top: 4px;
}

.upload-placeholder {
  border: 2px dashed rgba(0, 0, 0, 0.38);
  border-radius: 8px;
  min-height: 120px;
  min-width: 120px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  background: rgba(0, 0, 0, 0.02);
  transition: border-color 0.2s ease, background 0.2s ease;
  padding: 12px;
}

.upload-placeholder:hover {
  border-color: var(--v-primary-base, #1976d2);
  background: rgba(25, 118, 210, 0.04);
}

.upload-placeholder--single {
  width: 100%;
  max-width: 280px;
}

.upload-hint {
  margin-top: 8px;
  font-size: 0.75rem;
  color: rgba(0, 0, 0, 0.54);
}

.thumb-cell {
  position: relative;
  width: 120px;
  height: 120px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid rgba(0, 0, 0, 0.12);
  flex-shrink: 0;
}

.thumb-cell--single {
  width: 100%;
  max-width: 280px;
  height: 160px;
}

.thumb-cell img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  cursor: zoom-in;
  display: block;
}

.thumb-remove {
  position: absolute;
  top: 4px;
  right: 4px;
  background: rgba(0, 0, 0, 0.55) !important;
}

.thumb-checkbox {
  position: absolute;
  left: 4px;
  bottom: 2px;
  margin: 0 !important;
  background: rgba(255, 255, 255, 0.85);
  border-radius: 4px;
  padding: 0 4px;
}

.thumb-kind {
  position: absolute;
  top: 4px;
  left: 4px;
  font-size: 0.65rem;
  line-height: 1;
  font-weight: 700;
  color: #fff;
  background: rgba(0, 0, 0, 0.65);
  border-radius: 4px;
  padding: 4px 6px;
  z-index: 2;
}

.edit-delete-btn {
  position: absolute;
  left: 6px;
  bottom: 6px;
  min-width: 70px !important;
  z-index: 2;
}

.recepcion-dark .field-label {
  color: var(--v-tabText-base);
}

.recepcion-dark .contexto-caption {
  color: var(--v-swalText-base);
  opacity: 0.82;
}

.recepcion-dark .upload-placeholder {
  border-color: rgba(255, 255, 255, 0.32);
  background: rgba(255, 255, 255, 0.04);
}

.recepcion-dark .upload-placeholder:hover {
  border-color: var(--v-primary-base, #1976d2);
  background: rgba(25, 118, 210, 0.18);
}

.recepcion-dark .upload-hint {
  color: rgba(255, 255, 255, 0.72);
}

.recepcion-dark .thumb-cell {
  border-color: rgba(255, 255, 255, 0.28);
}

.recepcion-dark .thumb-checkbox {
  background: rgba(20, 20, 20, 0.9);
}

.recepcion-dark .thumb-checkbox ::v-deep .v-label,
.thumb-checkbox ::v-deep .v-label {
  color: rgba(255, 255, 255, 0.92) !important;
  font-size: 0.72rem;
}
</style>
